var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mark"},[_c('i',{staticClass:"iconfont icon-chenggong-icon"})]),_c('p',{staticClass:"warn"},[_vm._v("验证成功")]),_c('div',{staticClass:"shell"},[_c('a',{staticClass:"weui-btn weui-btn_warn btn",attrs:{"href":"/supermarket/html/publicPage/myload.html","id":"nextStep"}},[_vm._v("完成")])])])
}]

export { render, staticRenderFns }